import { getGtmData, GtmCustomData, recordEventWrapper } from '..';
import { replaceEmptySpaceWithHyphen } from '../../utils/common';

const investmentIdeas = () => ({
  invIdeasPageLoad: () => {
    recordEventWrapper({
      event: 'event_pfm_onload_vpv',
      page: 'vpv/pfm/mutual-funds/investment-ideas',
      title: 'PFM - Mutual Funds - Investment Ideas',
      cd24: getGtmData('cd24')
    }),
    recordEventWrapper({
      event: 'event_pfm_onload',
      category: 'PFM',
      action: 'Pageload',
      label: 'mutual funds | investment ideas'
    })
  },

  invIdeasBackClick: () => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: 'mutual funds | investment ideas',
      label: 'Back'
    })
  },

  //1557
  exploreEvent: (eventType: string) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: 'mutual funds | investment ideas',
      label: `${eventType}`,
    })
  },

  // 3. Scheme details Page 
  schemeDetailPageLoad: (scheme: string, invIdeaFundType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/explore-mutual-funds/explore-investment-ideas/${replaceEmptySpaceWithHyphen(invIdeaFundType, true)}/${scheme}/scheme-details`,
    //   title: `PFM - Online Investments - Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Scheme Details`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Scheme Details`
    // })
  },

  // actionType could be either Back or Click Here
  schemeListActionClick: (scheme: string, invIdeaFundType: string, actionType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Scheme Details - ${actionType}`
    // })
  },

  // data will have cd66 and cd68 as values.
  schemeListInvestClick: (scheme: string, invIdeaFundType: string, data: GtmCustomData, userFlow: any) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Invest`,
    //   ...data
    // })
  },

  // 4. Invest page
  // invIdeaFundType could be Invest in bluechip companies, index funds, international funds, etc.
  investPageLoad: (scheme: string, invIdeaFundType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/explore-mutual-funds/explore-investment-ideas/${replaceEmptySpaceWithHyphen(invIdeaFundType, true)}/${replaceEmptySpaceWithHyphen(scheme, true)}/home`,
    //   title: `PFM - Online Investments - Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Home`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Landing Screen`
    // })
  },

  // actionType can be Back, Terms and Conditions, Add Nominee, Edit Nominee
  investPageActionClick: (scheme: string, invIdeaFundType: string, actionType: string, userFlow?) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow?.toLowerCase()} | ${scheme}`,
      label: `${actionType}`
    })
  },

  // Data will have cd68, cd69 and cd70 values
  investPageContinueClick: (scheme: string, invIdeaFundType: string, data: GtmCustomData, userFlow?, isLumpsum?) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow?.toLowerCase()} | ${scheme}`,
      label: `continue | ${isLumpsum ? "Lumpsum" : "SIP"}`,
      ...data
    })
  },

  // 6. Nominee Modal
  nomineeModalPageLoad: (scheme: string, invIdeaFundType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/explore-mutual-funds/explore-investment-ideas/${replaceEmptySpaceWithHyphen(invIdeaFundType, true)}/${replaceEmptySpaceWithHyphen(scheme, true)}/home/add-nominee`,
    //   title: `PFM - Online Investments - Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Home - Add Nominee`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Landing Screen - Add Nominee`
    // })
  },

  // actionType can have Close, Remove, Add Another Nominee, Confirm Nominee as value.
  nomineeModalActionClick: (scheme: string, invIdeaFundType: string, actionType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Landing Screen - Add Nominee - ${actionType}`
    // })
  },

  // 7. OTP modal
  otpModalPageLoad: (scheme: string, invIdeaFundType: string, userFlow?) => {
    recordEventWrapper({
      event: 'event_pfm_onload_vpv',
      page: `/vpv/pfm/mutual-funds/${userFlow?.toLowerCase()}/otp-verification`,
      title: `PFM - Mutual Funds - ${userFlow?.toLowerCase()} - OTP Verification`
    }),
    recordEventWrapper({
      event: 'event_pfm_onload',
      category: 'PFM',
      action: 'Pageload',
      label: `mutual funds | ${userFlow?.toLowerCase()} - - otp verification`
    })
  },

  // actionType can be Close or Submit
  otpModalActionClick: (scheme: string, invIdeaFundType: string, actionType: string, userFlow?) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow?.toLowerCase()} - otp verification`,
      label: `success | ${scheme}`
    })
  },

  // 8. Success page
  // data will have cd71 value
  successPageLoad: (scheme: string, invIdeaFundType: string, data: GtmCustomData) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/explore-mutual-funds/explore-investment-ideas/${replaceEmptySpaceWithHyphen(invIdeaFundType, true)}/${replaceEmptySpaceWithHyphen(scheme, true)}/investment-successful`,
    //   title: `PFM - Online Investments - Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Investment Successful`,
    //   ...data
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Investment Successful`
    // })
  },

  successPageGoBackTextClick: (scheme: string, invIdeaFundType: string, goBackMessage: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Investment Successful - ${goBackMessage}`
    // })
  },

  successPageActionButtonsClick: (scheme: string, invIdeaFundType: string, actionButton: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Explore Investment Ideas - ${invIdeaFundType} - ${scheme} - Investment Successful - ${actionButton}`
    // })
  }

})

export default investmentIdeas;
